"use client";

import React, { useState } from 'react';
import AppLayout from '@/components/AppLayout';
import LivePlayer from './components/LivePlayer';
import LiveChat from './components/LiveChat';
import GossipQueue from './components/GossipQueue';
import { ShieldCheck } from 'lucide-react';

export default function LiveStreamPage() {
  const [isHost, setIsHost] = useState(false);

  return (
    <AppLayout hideFooter>
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16 py-6">
        <div className="flex items-center justify-end mb-3">
          <button
            onClick={() => setIsHost((v) => !v)}
            className={`flex items-center gap-2 text-xs font-semibold px-3 py-1.5 rounded-xl border transition-all ${
              isHost
                ? 'bg-primary text-white border-primary shadow-sm'
                : 'bg-card border-border text-muted-foreground hover:text-foreground hover:border-primary/40'
            }`}
          >
            <ShieldCheck size={14} />
            {isHost ? 'Modo Anfitriona activo' : 'Activar modo Anfitriona'}
          </button>
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-4 gap-6" style={{ minHeight: 'calc(100vh - 160px)' }}>
          {/* Main: Player + Queue */}
          <div className="xl:col-span-3 flex flex-col gap-5">
            <LivePlayer />
            <GossipQueue />
          </div>

          {/* Sidebar: Chat */}
          <div className="xl:col-span-1">
            <LiveChat isHost={isHost} />
          </div>
        </div>
      </div>
    </AppLayout>
  );
}